module.exports = __webpack_public_path__ + "static/media/download-app-mobile-background.c9d7c2de.png";